import { type DataTableSemantics } from 'src/registry/components/table/types';
import { Badge } from 'src/registry/ui/Badge';
import { Skeleton } from 'src/registry/ui/Skeleton';

type DataTableHeadProps = {
    semantics: DataTableSemantics;
    isLoading?: boolean;
    count?: number;
};

export function DataTableHead({ semantics, isLoading, count }: DataTableHeadProps) {
    return (
        <div className="flex items-center gap-4 p-4">
            <h2 className="text-lg font-semibold">{semantics.title}</h2>
            {isLoading || count === undefined ? (
                <Skeleton className="h-6 w-24" />
            ) : (
                count != null && (
                    <Badge theme="primary" className="shrink-0">
                        {count} {count === 1 ? semantics.entryName : semantics.entryNames}
                    </Badge>
                )
            )}
        </div>
    );
}
